import { Linkedin, MessageSquare } from "lucide-react";
import { Link } from "@tanstack/react-router";

const socialLinks = [
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@adapted_sa?is_from_webapp=1&sender_device=pc",
    icon: TikTokIcon,
    external: true,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/adapt-ed-rsa/",
    icon: Linkedin,
    external: true,
    target: "_top",
  },
  {
    label: "Contact us",
    href: "/contact",
    icon: MessageSquare,
    external: false,
  },
];

function TikTokIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z" />
    </svg>
  );
}

export function SocialLinksBar() {
  return (
    <div className="flex items-center gap-3">
      {socialLinks.map((link) => {
        const Icon = link.icon;
        const className =
          "inline-flex size-10 items-center justify-center rounded-full border border-ink-foreground/15 bg-ink-foreground/[0.04] text-ink-foreground/80 backdrop-blur-sm transition-all hover:scale-105 hover:border-primary/40 hover:bg-primary/10 hover:text-primary-on-ink";
        return link.external ? (
          <a
            key={link.label}
            href={link.href}
            target={link.target ?? "_blank"}
            rel="noreferrer"
            aria-label={link.label}
            className={className}
          >
            <Icon className="size-5" />
          </a>
        ) : (
          <Link
            key={link.label}
            to={link.href}
            aria-label={link.label}
            className={className}
          >
            <Icon className="size-5" />
          </Link>
        );
      })}
    </div>
  );
}
